import React from 'react';

const Button = ({ className, onClick, children }) => (
    <button
        type="button"
        className={`relative overflow-hidden py-3 px-5 rounded-md ripple-effect ${className}`}
        onClick={onClick}
    >
        <span className="relative z-10 gap-2">{children}</span>
    </button>
);


export default Button;
